import * as React from 'react';
import Svg, { SvgProps, G, Path, Mask, Rect } from 'react-native-svg';

export function ItalianFlagSvg(props: SvgProps) {
  return (
    <Svg
      width={24}
      height={18}
      viewBox="0 0 24 18"
      fill="none"
      {...props}
    >
      <Mask id="mask0_634_26191" x={0} y={0} width={24} height={18}>
        <Rect width={24} height={18} fill="white" />
      </Mask>
      <G mask="url(#mask0_634_26191)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8008 0H24.0008V18H16.8008V0Z"
          fill="#C51918"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H7.2V18H0V0Z"
          fill="#5EAA22"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19922 0H16.7992V18H7.19922V0Z"
          fill="white"
        />
      </G>
    </Svg>
  );
}
